import { apiClient } from './client';

export async function loginWithEmail(email, password) {
  const { data } = await apiClient.post('/login', { email, password });
  return data;
}

export function extractAuthFromResponse(data, fallbackEmail) {
  const payload = data?.data ?? data;
  const token = payload?.token || payload?.access_token;
  const user = payload?.user || {};
  const email = (user.email || fallbackEmail || '').trim().toLowerCase();

  return { token, email, user };
}
